import React from 'react';

import LegacyLinkComponent from '~/components/LegacyLinkComponent';
import type { LinkComponentType } from '~/layouts/AppMarketHomeLink';

type MobileAppContextType = {
  LinkComponent: LinkComponentType;
};

export const MobileAppContext = React.createContext({
  LinkComponent: LegacyLinkComponent,
} as MobileAppContextType);

export const useMobileAppContext = () => {
  const ctx = React.useContext(MobileAppContext);

  return ctx;
};

export const useLinkComponent = () => {
  return useMobileAppContext().LinkComponent;
};

export const MobileAppContextProvider = ({
  children,
  LinkComponent = LegacyLinkComponent,
}: {
  children: React.ReactNode;
  LinkComponent?: LinkComponentType;
}) => {
  return (
    <MobileAppContext.Provider value={{ LinkComponent }}>
      {children}
    </MobileAppContext.Provider>
  );
};
